<template>
  <div class="page-3-wrapper">
    <img class="bg" :src="source('page-3-bg')" alt="" draggable="false">
    <div class="problem-list-wrapper" ref="listRef">
      <div>Spatial Immersion</div>
      <div>Innovation And Creativity</div>
      <div>Arts And Science</div>
      <div>Experience Upgrade</div>
    </div>
    <img class="view-more-btn" :src="source('view-more-btn')" @click="toPage('/who-we-are')" draggable="false" >
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'page-3',
  components: { },
  data() {
    return {
      animationList: [
        [{ transform: 'translateX(100vw)' }, { transform: 'translateX(0)' }],
        [{ transform: 'translateX(-100vw)' }, { transform: 'translateX(0)' }],
        { duration: 2000, fill: 'forwards', easing: 'ease' }
      ]
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME, name).fileUrl
    },
    obsAnimation(el, fun, isUnobserve = false) {
      const ob = new IntersectionObserver(e => {
        if (!e[0].isIntersecting) return
        fun(el)
        if (isUnobserve) ob.unobserve(el)
      })
      ob.observe(el)
    },
    listAnimation() {
      this.obsAnimation(this.$refs.listRef, (el) => {
        for (let i = 0; i < el.children.length; i++) {
          el.children[i].animate(this.animationList[[0, 2].includes(i) ? 0 : 1], this.animationList[2])
        }
      }, true)
    }
  },
  mounted() {
    this.listAnimation()
  }
}
</script>

<style scoped lang="scss">
.page-3-wrapper {
  position: relative;
  width: 100vw;
  height: 56.25vw;
  overflow: hidden;
  .problem-list-wrapper {
    position: absolute;
    top: 9.083vw;
    height: 4.115vw;
    font-size: 4.583vw;
    font-weight: 900;
    color: #FFFFFF;
    line-height: 4.115vw;
    transition: all 1s;

    :nth-child(1) {
      margin-top: 2vw;
      margin-left: 16.542vw;
      transition: all 1s;
    }

    :nth-child(2) {
      margin-top: 3vw;
      margin-left: 37.781vw;
      transition: all 1s;
    }

    :nth-child(3) {
      margin-top: 3vw;
      margin-left: 10.687vw;
      transition: all 1s;
    }

    :nth-child(4) {
      margin-top: 3vw;
      margin-left: 34.083vw;
      transition: all 1s;
    }
  }

  .view-more-btn{
    width: 16.51vw;
    height: 3.12vw;
    position: absolute;
    left: 41.74vw;
    top: 46.7vw;
    cursor: pointer;
  }
}
</style>
